import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {graphql} from 'react-relay';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation createTaskSetMutation($input: CreateTaskSetInput!) {
		createTaskSet(input: $input) {
			taskSet {
				id
				name
				frequency
				intervalLength
				weekdays
				monthlyWeekday
				monthlyMode
				seedDate
				boundType
				boundCount
				boundEndDate
				materialisedTo
				instanceCount
				# Present only when generation stopped part way. The set and the
				# instances made so far exist; the drawer warns rather than failing.
				generationShortfall {
					createdCount
					remainingCount
				}
			}
			# The project too, not just the set. This creates many tasks rather than
			# one, so the client refetches the scoping view from here instead of
			# trying to insert N rows into the store by hand.
			project {
				id
			}
			# The instances, in the field set the scheduling canvas builds its items
			# from -- the same one the create-task mutation returns for a single task.
			# The timeline draws from its own data rather than the Relay store, so it
			# places these on the canvas as soon as they exist; the scoping page
			# ignores them and refetches instead.
			tasks {
				id
				# PIKA-748 F1: the chip's own data. Without it a freshly created set
				# draws plain bars until a reload refetches /scheduling -- which is the
				# moment a run of identically-named instances is least distinguishable
				# from hand-duplicated tasks, and exactly what AC7 exists to prevent.
				#
				# The scheduling payload is where membership normally comes from, and it
				# is not refetched on create; onTaskUpdated has no previous task to copy
				# from either, because the instance is new. So it has to arrive here.
				taskSet {
					id
				}
				taskSetSequence
				approved
				assignedPersons {
					id
				}
				billable
				blocked
				bug
				companyTaskId
				startDay
				startMonth
				startYear
				deadlineDay
				deadlineMonth
				deadlineYear
				done
				estimateForecast
				estimateForecastMinutes
				highPriority
				progress
				userCanDeleteTask
				userCantDeleteTaskReason
				timeLeft
				timeLeftMinutesWithoutFutureTimeRegs
				name
				project {
					id
					completion
					remaining
					forecast
				}
				role {
					id
				}
				phase {
					id
				}
				statusColumnV2 {
					id
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	// weekdayCount rather than the days themselves: the question this has to
	// answer is which patterns customers actually use, and a count answers it
	// without carrying more than is needed.
	tracking.trackEvent('Task Set Created', {
		_Frequency: input.frequency,
		_WeekdayCount: (input.weekdays || []).length,
		_BoundType: input.boundType,
	});
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
